<template>
  <base-section id="committee">
    <v-container>
    <base-section-heading
    title="Organizing Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
    <v-col
      cols="12"
      md="6"
    >
    <strong>General Co-Chairs<br /></strong>
    Victor Champac<br />
    Yervant Zorian - Synopsys, USA<br />
    <br /><strong>Vice General Chair<br /></strong>
    Carlos Silva Cardenas - Pontificia Universidad Católica del Perú, Peru<br />
    <br /><strong>Local Co-Chairs<br /></strong>
    Jimmy Fernando Tarrillo - UTEC, Peru<br />
    Juan Tisza - National University of Engineering, Peru<br />
    <br /><strong>Program Co-Chairs<br /></strong>
    Leticia Bolzani Poehls - IHP, Germany<br />
    Ernesto Sanchez - Politecnico di Torino, Italy<br />
    <br /><strong>Embedded Tutorial Co-Chairs<br /></strong>
    Ioana Vatajelu - TIMA Laboratory, France<br />
    Angeliki Kritikakou - Rennes University, France<br />
    <br /><strong>Special Session Co-Chairs<br /></strong>
    Graziano Pravadelli - University of Verona, Italy<br />
    Felipe Restrepo Calle - Universidad Nacional de Colombia, Colombia<br />
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
    <strong>Panel Co-Chairs<br /></strong>
    Fabian Luis Vargas - IHP, Germany<br />
    Marcelo Lubaszewski - UFRGS, Brazil<br />
    <br /><strong>Student Activities Co-Chairs<br /></strong>
    Annachiara Ruospo - Politecnico di Torino, Italy<br />
    Cristina Meinhardt - UFSC, Brazil<br />
    <br /><strong>Financial Co-Chair<br /></strong>
    Hector Villacorta - Universidad Politécnica de Aguascalientes, Mexico<br />
    <br /><strong>Web Chair<br /></strong>
    Giusy Iara - Politecnico di Torino, Italy<br />
    <br /><strong>Publicity Co-Chair<br /></strong>
    Nicolo Bellarmino - Politecnico di Torino, Italy<br />
    <br /><strong>USA Liaison<br /></strong>
    Abhijit Chatterje - Georgia Tech, USA<br />
    <br /><strong>Asia Liaison<br /></strong>
    Xiaoqing Wen - Kyushu Institute of Technology, Japan<br />
    <br /><strong>Europe Liaison<br /></strong>
    Matteo Sonza Reorda - Politecnico di Torino, Italy<br />
    </v-col>
    </v-row>
    </base-section-heading>
    <base-section-heading
    title="Steering Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
      <v-col
        v-for="(program, i) in steerings"
        :key="i"
        cols="12"
        md="6"
      >
        <base-section
          space="0"
          style="text-align: left"
        >
          {{ program.title }} - <i>{{ program.text }}</i>
        </base-section>
      </v-col>
    </v-row>
    </base-section-heading>
    <base-section-heading
    title="Program Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
      <v-col
        v-for="program in programs"
        :key="program.title"
        cols="12"
        md="6"
      >
        <base-section
          space="0"
          style="text-align: left"
        >
          {{ program.title }}<template v-if="program.text"> - <i>{{ program.text }}</i></template>
        </base-section>
      </v-col>
    </v-row>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Committee',

    data: () => ({
      steerings: [
          {
          text: "INAOE, Mexico",
          title: "Victor Champac",
          },
          {
          text: "UFRGS, Brazil",
          title: "Marcelo Lubazewski ",
          },
          {
          text: "IHP GmbH, Germany",
          title: "Fabian Vargas",
          },
          {
          text: "TIMA, France",
          title: "Raoul Velazco",
          },
          {
          text: "Synopsys, USA",
          title: "Yervant Zorian",
          },
          {
          text: "UFRGS, Brazil",
          title: "Tiago Balen",
          },
          {
          text: "Politecnico di Torino, Italy",
          title: "Ernesto Sanchez",
          },
          {
          text: "IHP - Leibniz Institute for High Performance Microelectronics, Germany",
          title: "Leticia M. Bolzani Pöhls",
          },
          {
          text: "Politecnico di Torino, Italy",
          title: "Matteo Sonza Reorda",
          },
      ],
      programs: [
        {
          title: "Salvador Mir",
          text: "TIMA Laboratory",
        },
        {
          title: "Julio Perez Acle",
          text: "Universidad de la Republica",
        },
        {
          title: "Alex Orailoglu",
          text: "University of California San Diego",
        },
        {
          title: "Kentaroh Katoh",
          text: "Dept. of Electronics Engineering and Computer Science, Faculty of Engineering Fukuoka University",
        },
        {
          title: "Hector Villacorta",
          text: "Semtech",
        },
        {
          title: "Mohammad Hasan Ahmadilivani",
          text: "Tallinn University of Technology",
        },
        {
          title: "Gurgen Harutyunyan",
          text: "Synopsys",
        },
        {
          title: "Fernando Fernandes Dos Santos",
          text: "UFRGS",
        },
        {
          title: "Ernesto Sanchez",
          text: "Politecnico di Torino",
        },
        {
          title: "Hans-Joachim Wunderlich",
          text: "University of Stuttgart",
        },
        {
          title: "Lorena Anghel",
          text: "Grenoble INP, University of Grenoble Alpes",
        },
        {
          title: "Matteo Sonza Reorda",
          text: "Politecnico di Torino",
        },
        {
          title: "Angeliki Kritikakou",
          text: "University of Rennes 1 - IRISA/INRIA",
        },
        {
          title: "Ramesh Karri",
          text: "New York University",
        },
        {
          title: "Nicola Nicolici",
          text: "McMaster University",
        },
        {
          title: "Marcello Traiola",
          text: "Inria Rennes / IRISA",
        },
        {
          title: "Marcelo Lubaszewski",
          text: "UFRGS Federal University",
        },
        {
          title: "Antonio Miele",
          text: "Politecnico di Milano",
        },
        {
          title: "Fabian Vargas",
          text: "Catholic University - PUCRS",
        },
        {
          title: "Milos Krstic",
          text: "IHP GmbH",
        },
        {
          title: "Sybille Hellebrand",
          text: "University of Paderborn",
        },
        {
          title: "Haralampos-G. Stratigopoulos",
          text: "Sorbonne Université, CNRS, LIP6",
        },
        {
          title: "Regis Leveugle",
          text: "Grenoble-INP/TIMA",
        },
        {
          title: "Felipe Restrepo-Calle",
          text: "Universidad Nacional de Colombia",
        },
        {
          title: "Frank Sill Torres",
          text: "German Aerospace Center (DLR)",
        },
        {
          title: "Dimitris Gizopoulos",
          text: "University of Athens",
        },
        {
          title: "Marko Andjelkovic",
          text: "IHP",
        },
        {
          title: "Mario Schölzel",
          text: "University of Applied Sciences Nordhausen",
        },
        {
          title: "Cristina Meinhardt",
          text: "UFSC",
        },
        {
          title: "Lirida Naviner",
          text: "Institut TELECOM, Télécom-ParisTech",
        },
        {
          title: "José Augusto Nacif",
          text: "Universidade Federal de Viçosa",
        },
        {
          title: "José Lipovetzky",
          text: "Devices and Sensors Group, Bariloche Atomic Center, CNEA",
        },
        {
          title: "Rolf Drechsler",
          text: "Universität Bremen",
        },
        {
          title: "Supriya Chakraborty",
          text: "RWTH Aachen University, Aachen",
        },
        {
          title: "Mounir Benabdenbi",
          text: "Grenoble INP- TIMA Laboratory",
        },
        {
          title: "Erik Larsson",
          text: "Lund University",
        },
        {
          title: "Emmanuel Simeu",
          text: "TIMA Laboratory",
        },
        {
          title: "Lorenzo Casalino",
          text: "CentraleSupélec, Inria, IRISA",
        },
        {
          title: "Adit Singh",
          text: "Auburn University",
        },
        {
          title: "Antonio Zenteno Ramirez",
          text: "Intel",
        },
        {
          title: "Paolo Maistri",
          text: "TIMA Laboratory",
        },
        {
          title: "Moritz Fieback",
          text: "Delft University of Technology",
        },
        {
          title: "Patrick Girard",
          text: "LIRMM",
        },
        {
          title: "Giorgio Di Natale",
          text: "CNRS",
        },
        {
          title: "Rodrigo Possamai Bastos",
          text: "Univ. Grenoble Alpes, CNRS, TIMA",
        },
        {
          title: "Florence Azais",
          text: "Univ. Montpellier, CNRS, LIRMM",
        },
        {
          title: "Mihalis Psarakis",
          text: "University of Piraeus",
        },
        {
          title: "Maksim Jenihhin",
          text: "Tallinn University of Technology",
        },
        {
          title: "Fernanda Kastensmidt",
          text: "Universidade Federal do Rio Grande do Sul - UFRGS",
        },
        {
          title: "Stefano Dicarlo",
          text: "Politecnico di Torino",
        },
        {
          title: "Luca Sterpone",
          text: "Politecnico di Torino",
        },
        {
          title: "Ioana Vatajelu",
          text: "INP - TIMA Laboratory",
        },
        {
          title: "Goerschwin Fey",
          text: "TUHH",
        },
        {
          title: "Ygor Aguiar",
          text: "CERN",
        },
      ],

    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
</style>
